<template>
	<div class="christmas-offer-title">
		<ChristmasOfferRibbon class="christmas-offer-title__ribbon">
			{{ t('offers.christmas.paywall.title.ribbon_text') }}
		</ChristmasOfferRibbon>
		<h1>{{ t('offers.christmas.paywall.title.offer', { count: 50 }) }}</h1>
		<h2>{{ t('offers.christmas.paywall.title.offer_name') }}</h2>
	</div>
</template>

<style lang="scss" scoped>
.christmas-offer-title {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 2rem;

	&__ribbon {
		max-width: 220px;
		left: 1rem;
		margin-bottom: 0.5rem;
	}

	h2 {
		margin: 0;
		font-style: italic;
		font-weight: 900;
		font-size: 2.2rem;
		text-transform: uppercase;
		color: #ffffff;
		line-height: 1.1;
		text-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2);
	}

	h1 {
		margin: 0;
		font-style: italic;
		font-weight: 900;
		font-size: 4.3rem;
		line-height: 1.1;
		letter-spacing: -2.06495px;
		text-transform: uppercase;
		color: #ffffff;
		text-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2);
	}
}

[lang='es'],
[lang='de'],
[lang='ru'] {
	.christmas-offer-title {
		h1 {
			font-size: 3.2rem;
		}

		h2 {
			font-size: 1.9rem;
		}
	}
}

[lang='pt'] {
	.christmas-offer-title {
		h1 {
			font-size: 4rem;
		}

		h2 {
			font-size: 2rem;
		}
	}
}

[lang='it'],
[lang='fr'] {
	.christmas-offer-title {
		h2 {
			font-size: 2rem;
		}
	}
}
</style>

<script>
import { computed } from '@vue/reactivity'
import { useI18n } from 'vue-i18n'
import ChristmasOfferRibbon from './ChristmasOfferRibbon.vue'

export default {
	name: 'ChristmasOfferTitle',
	props: {
		name: {
			type: String,
			default: 'Alex'
		},
		targetWeight: {
			type: Number,
			default: 70
		},
		daysToGoal: {
			type: Number,
			default: 0
		},
		isMetric: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const { t } = useI18n()
		const weight = computed(
			() =>
				`${Math.trunc(props.isMetric ? props.targetWeight : props.targetWeight * 2.205).toString()}${
					!props.isMetric ? 'lbs' : 'kg'
				}`
		)
		return {
			t,
			weight
		}
	},
	components: { ChristmasOfferRibbon }
}
</script>
